import React from "react";
import { getValue } from "@utils/lodash";

function FilterSubheaderSvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" 
      height={
        getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
      }
      width={
        getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
      }
      viewBox="0 0 24 24">
      <defs>
        <clipPath id="clip-path-filter">
          <rect id="Rectangle_18196" data-name="Rectangle 18196" width="24" height="24" transform="translate(-14694 -8279)" fill="#fff"/>
        </clipPath>
      </defs>
      <g id="Mask_Group_304" data-name="Mask Group 304" transform="translate(14694 8279)" clip-path="url(#clip-path-filter)">
        <path id="filter_alt_FILL0_wght300_GRAD0_opsz24" d="M14.855-15.2a.95.95,0,0,1-.691-.271.9.9,0,0,1-.278-.673v-6.174L7.758-29.9a.749.749,0,0,1-.092-.853.781.781,0,0,1,.757-.443h14.21a.781.781,0,0,1,.757.443.749.749,0,0,1-.092.853L17.17-22.318v6.174a.9.9,0,0,1-.278.673.95.95,0,0,1-.691.271H14.855Zm.674-7.68,5.419-6.72H10.109ZM15.528-22.88Z" transform="translate(-14697.528 -8243.8)"  fill={
          getValue(props, `color`, "")
            ? getValue(props, `color`, "")
            : "#5f6368"
        } />
      </g>
    </svg>

  );
}

export default FilterSubheaderSvgComponent;
